import { render, staticRenderFns } from "./CartHeader.vue?vue&type=template&id=28f6f680&scoped=true"
import script from "./CartHeader.vue?vue&type=script&lang=js"
export * from "./CartHeader.vue?vue&type=script&lang=js"
import style0 from "./CartHeader.vue?vue&type=style&index=0&id=28f6f680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f6f680",
  null
  
)

export default component.exports